import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
const whatsappScreenshots = ['https://cdn.magicpatterns.com/uploads/8boRHpSQpv2MeH8mL1TRnq/Diseno_sin_titulo_(8).png', 'https://cdn.magicpatterns.com/uploads/tHgnRBo1m5GsuNk4ydSYTZ/Diseno_sin_titulo_(7).png', 'https://cdn.magicpatterns.com/uploads/rX5dX2TT97ZRnk14TBT3aF/Diseno_sin_titulo_(6).png'];
export function TransformationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0D002B] py-24 md:py-32" data-id="element-356" data-mp="2e6wcdlak12hq">
      <div className="mx-auto max-w-6xl px-6" data-id="element-357" data-mp="2e51teciufkga">
        <motion.div initial={{
        opacity: 0,
        y: 28
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 28
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-358" data-mp="298ulie6vzyvp">
          <div className="mx-auto mb-12 max-w-2xl text-center" data-id="element-359" data-mp="k33qweuvcvxc">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-[#7C3AED]/20 px-4 py-1.5 text-sm font-bold tracking-wide text-[#C4B5FD]" data-id="element-360" data-mp="5do6dglxlmq3">
              <MessageCircleIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-361" data-mp="a9mwb8mwrcsm" />
              TESTIMONIOS REALES
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-white md:text-4xl lg:text-5xl" data-id="element-362" data-mp="12ykg5g6rphnh">
              Lo que cuentan las parejas después de aplicar el plan
            </h2>
            <p className="mt-5 text-lg text-[#C4B5FD]" data-id="element-363" data-mp="t0nw1yvurcd8">
              Capturas compartidas por quienes ya usaron las herramientas en su
              día a día.
            </p>
          </div>

          <div className="-mx-6 overflow-x-auto px-6 pb-8 snap-x snap-mandatory [scrollbar-width:none]" data-id="element-364" data-mp="3du9dssyx07r3">
            <div className="mx-auto flex w-max gap-6 md:gap-8" data-id="element-365" data-mp="1k97ieycpzhwp">
              {whatsappScreenshots.map((image, index) => <motion.figure key={image} initial={{
              opacity: 0,
              y: 24
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 24
            }} transition={{
              duration: 0.55,
              delay: 0.12 * index,
              ease: 'easeOut'
            }} className="relative w-[278px] shrink-0 snap-center overflow-hidden rounded-[28px] border-2 border-[#7C3AED]/30 bg-[#1A0050] p-2 md:w-[320px]" data-id="element-366" data-mp="1ak65xi5dvinh" data-mpi={index}>
                  <div className="absolute left-1/2 top-2 z-10 h-5 w-20 -translate-x-1/2 rounded-b-2xl bg-black" aria-hidden="true" data-id="element-367" data-mp="2pg7elxmqxu2j" />
                  <img src={image} alt={`Testimonio real de cliente ${index + 1}`} loading="lazy" className="block h-auto w-full rounded-[21px]" data-id="element-368" data-mp="2y9apby60bsth" />
                </motion.figure>)}
            </div>
          </div>
          <p className="mt-2 text-center text-sm italic text-[#A78BFA]" data-id="element-369" data-mp="2akrizo6ipq41">
            Deslizá para ver los tres mensajes.
          </p>
        </motion.div>
      </div>
    </section>;
}